// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236A6A6A%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissions-page .room-settings-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}

.permissions-page .room-settings-section-title {
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #434343;
  margin: 0;
}

.permissions-page .room-settings-description {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  line-height: 1.2;
  letter-spacing: 0.3px;
  margin: 0;
}

.permissions-page .room-settings-section-divider {
  height: 1px;
  background-color: #979797;
  width: 100%;
  margin-top: 8px;
}

.permissions-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.permission-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.permission-label {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #2D2D2D;
  line-height: 1.2;
}

.permission-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.permission-select {
  padding: 6px 16px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  background-color: #F2F2F2;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
  height: 32px;
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

.permission-select:hover:not(:disabled) {
  border-color: #9B9B9B;
}

.permission-select:focus {
  outline: none;
  border-color: #9B9B9B;
}

.permission-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.permission-custom-input-container {
  position: relative;
}

.permission-custom-input {
  padding: 6px 16px;
  border: 1px solid #9B9B9B;
  border-radius: 8px;
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  width: 140px;
  height: 32px;
  box-sizing: border-box;
  background-color: #F2F2F2;
}

.permission-custom-input:focus {
  outline: none;
  border-color: #666;
}

.permission-custom-value {
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 12px;
  color: #6A6A6A;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.permission-custom-value-clickable {
  cursor: pointer;
}

.permission-custom-value-clickable:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/PermissionsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;EAC3F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6FAA6F;EAC7F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6FAA6F;EAC7F,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6FAA6F;EAC7F,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".permissions-page .room-settings-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.permissions-page .room-settings-section-title {\n  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #434343;\n  margin: 0;\n}\n\n.permissions-page .room-settings-description {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  line-height: 1.2;\n  letter-spacing: 0.3px;\n  margin: 0;\n}\n\n.permissions-page .room-settings-section-divider {\n  height: 1px;\n  background-color: #979797;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.permissions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.permission-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.permission-label {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #2D2D2D;\n  line-height: 1.2;\n}\n\n.permission-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.permission-select {\n  padding: 6px 16px;\n  border: 1px solid #D8D8D8;\n  border-radius: 8px;\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  background-color: #F2F2F2;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px;\n  height: 32px;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236A6A6A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n.permission-select:hover:not(:disabled) {\n  border-color: #9B9B9B;\n}\n\n.permission-select:focus {\n  outline: none;\n  border-color: #9B9B9B;\n}\n\n.permission-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.permission-custom-input-container {\n  position: relative;\n}\n\n.permission-custom-input {\n  padding: 6px 16px;\n  border: 1px solid #9B9B9B;\n  border-radius: 8px;\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  width: 140px;\n  height: 32px;\n  box-sizing: border-box;\n  background-color: #F2F2F2;\n}\n\n.permission-custom-input:focus {\n  outline: none;\n  border-color: #666;\n}\n\n.permission-custom-value {\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 12px;\n  color: #6A6A6A;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.permission-custom-value-clickable {\n  cursor: pointer;\n}\n\n.permission-custom-value-clickable:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
